const hasLocalStorage = typeof localStorage !== 'undefined'
const env = (hasLocalStorage && localStorage['BACKEND_ENVIRONMENT']) || ''

export const BACKEND_ENVIRONMENT =
  env === 'production'
    ? 'production'
    : env.indexOf('local') === 0 // 'local' or 'localhost'
    ? 'localhost'
    : env.indexOf('dev') === 0 // 'dev', 'develop' or 'development'
    ? 'development'
    : typeof window !== 'undefined' && window.location.host !== 'terminalplanner.teqplay.nl'
    ? 'development'
    : 'production'

export const BASE_URL =
  BACKEND_ENVIRONMENT === 'development'
    ? 'https://backendterminalplanner.dev.teqplay.com'
    : BACKEND_ENVIRONMENT === 'localhost'
    ? 'http://localhost:8080'
    : 'https://backendterminalplanner.teqplay.nl'

if (hasLocalStorage) {
  // only output this info when running in a browser, not in unit tests
  console.info(
    'To change the BACKEND_ENVIRONMENT, ' +
      'set a value BACKEND_ENVIRONMENT in localstorage. ' +
      'Available values: production, development, localhost.'
  )
  console.info('BACKEND_ENVIRONMENT:', BACKEND_ENVIRONMENT)
  console.info('BASE_URL:', BASE_URL)
}

// MAPTILER
export const MAPTILER_TOKEN = 'clGemZEqKdXqO6nY5u9l'
export const MAP_URL = `https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=${MAPTILER_TOKEN}`

// MomentJs date format string that should be reused for all visit start dates
export const startDateFormatString = 'DD/MM/YYYY HH:mm'

export const simpleFormatDateString = 'DD-MM-YYYY'
export const simpleFormatTimeString = 'HH:mm'

export const ONE_HOUR_IN_MS = 3600000

export const POSSIBLE_DISPLAY_FIELDS_TERMINAL_VISIT = ['origin', 'destination', 'product', 'orderNumber']

export const APP_TERMINAL_IDS = Object.freeze({
  yara: 'nltnz_yara',
  cargillIzegem: 'beizg_cargill',
  cargillBotlek: 'nlrtm_cargill',
  cargillAms: 'nlams_cargill',
  teqplay: 'nltpl_teqplay'
})

// TODO: move this into the terminal configuration that is stored on the backend
export const SEA_SHIP_SHADOW_CONFIGURATION = [
  {
    terminalId: APP_TERMINAL_IDS.cargillAms,
    quay: 'Sea quay',
    offset: -12,
    minBollard: undefined,
    maxBollard: undefined
  },
  {
    terminalId: APP_TERMINAL_IDS.cargillBotlek,
    quay: 'seaquay',
    offset: 6,
    minBollard: 24,
    maxBollard: undefined
  }
]

export const CARGO_OPERATIONS_EMAIL_ADDRESSES =
  BACKEND_ENVIRONMENT === 'production'
    ? ['Beizcallno@cargill.com', 'Inbound_Planning@cargill.com']
    : ['developer@teqplay.nl']

export const CARGO_OPERATIONS_REPLY_TO_EMAIL =
  BACKEND_ENVIRONMENT === 'production' ? 'Beizcallno@cargill.com' : 'developer@teqplay.nl'

// feature switch to enable new features for specific users only
export const USER_FEATURES = {
  KPI: 'kpi',
  botlekExport: 'botlek-export'
}

/**
 * Possible statuses for terminal visits
 */
export const VISIT_STATUSES = Object.freeze({
  moored: 'moored',
  sailed: 'sailed',
  nearby: 'nearby',
  assigned: 'assigned',
  planned: 'planned'
})

export const USER_ROLES = Object.freeze({
  planner: 'ROLE_PLANNER',
  admin: 'ROLE_ADMIN',
  readOnly: 'ROLE_READONLY',
  orderAdmin: 'ROLE_ORDER_ADMIN',
  quayCoordinator: 'ROLE_QUAY_COORDINATOR'
})

export const OPERATIONS = Object.freeze({
  loading: 'Loading',
  unloading: 'Unloading'
})

/**
 * Configuration for terminal visit delays.
 * Values correspond to the enum of delay reasons configured on backend.
 */
export const VISIT_DELAY_COLORS = Object.freeze({
  RAIN: '#098cff',
  MANPOWER: '#d3ffcd',
  TECHNICAL: '#ff4733',
  EXTERNAL_ANALYSIS: '#8dd7ff',
  INTERNAL_ANALYSIS: '#ffefcb',
  FOOD_SAFETY: '#ffa58a'
})

/**
 * Color palette to be used in KPI charts for entities without a configured color.
 * @type {ReadonlyArray<*>}
 */
export const kpiColorPalette = Object.freeze([
  '#555B6E',
  '#89B0AE',
  '#2fa3e3',
  '#8bfa69',
  '#FFD6BA',
  '#9B1D20',
  '#1B998B',
  '#1E2019',
  '#73553c'
])

export const CARGO_DETAILS_TYPE = {
  yara: 'yara',
  cargill: 'cargill'
}

export const CARGO_DETAILS_CONFIG = {
  yara: [APP_TERMINAL_IDS.yara],
  cargill: [
    APP_TERMINAL_IDS.cargillIzegem,
    APP_TERMINAL_IDS.cargillBotlek,
    APP_TERMINAL_IDS.cargillAms,
    APP_TERMINAL_IDS.teqplay
  ]
}

/**
 * Quay types on terminal
 */
export const QUAY_ROLES = {
  external: 'EXTERNAL',
  normal: 'NORMAL',
  layby: 'LAYBY'
}

export const DEFAULT_PLANNING_DELAY = ONE_HOUR_IN_MS
